<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_787_837)">
<path d="M7.10995 8.53L5.69995 7.11C4.79995 8.27 4.23995 9.61 4.06995 11H6.08995C6.22995 10.13 6.57995 9.28 7.10995 8.53ZM6.08995 13H4.06995C4.23995 14.39 4.78995 15.73 5.68995 16.89L7.09995 15.47C6.57995 14.72 6.22995 13.88 6.08995 13ZM7.09995 18.32C8.25995 19.22 9.60995 19.76 10.9999 19.93V17.9C10.1299 17.75 9.28995 17.41 8.53995 16.87L7.09995 18.32ZM12.9999 4.07V1L8.44995 5.55L12.9999 10V6.09C15.8399 6.57 17.9999 9.03 17.9999 12C17.9999 14.97 15.8399 17.43 12.9999 17.91V19.93C16.9499 19.44 19.9999 16.08 19.9999 12C19.9999 7.92 16.9499 4.56 12.9999 4.07Z" fill="#323232"/>
</g>
<defs>
<clipPath id="clip0_787_837">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
